module.exports = __webpack_public_path__ + "img/multipubblicazione.187a0544.svg";